import "./TextareaInput.scss";

import { Component, h, render } from "preact";

import { getCustomText } from "@/utils/getCustomText";

export function TextareaInput({
  onChange,
  value = "",
  rows = 7,
  required = false,
}) {
  return (
    <div className="CCTextareaInput t-text">
      <label className="CCTextareaInput__label">
        {getCustomText("reviewFormFields.reviewLabel")}
      </label>

      <textarea
        rows={rows}
        className="CCTextareaInput__input t-text"
        onChange={(e) => onChange(e.target.value)}
        required={required}
      >
        {value}
      </textarea>
    </div>
  );
}
